<mat-card class="default has-progress-bar">
  <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'"></mat-progress-bar>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>{{title | translate}}</span>
    <button
      mat-icon-button
      (click)="contentExpanded = !contentExpanded"
    >
      <mat-icon>{{ contentExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>
    </button>
  </mat-card-title>
    <mat-expansion-panel [expanded]="contentExpanded">

      <ng-content></ng-content>
    </mat-expansion-panel>
</mat-card>
